import React, { Fragment } from 'react';
import PropTypes from 'proptypes';

const VisaChecklistModal = ({ closeModal, mailingCountry }) => (
  <div>
    <div className="row">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
    </div>
    <h4>Checklist</h4>
    <ul>
      <li>Name of Travel Agent/Tour Operator: Growth International Volunteer Excursions</li>
      <li>
        Contact Person in Tanzania: David Chogo; Address: Arusha, Tanzania; Phone: +255 716-174-776
      </li>
      <li>
        Date of Entry and Departure Dates: Write in your GIVE trip dates/the dates you arrive and
        depart Tanzania
      </li>
      <li>Duration of Stay: Write in the amount of days you will be in Tanzania</li>
      <li>Type of Visa Requested: Travel/Tourist Visa</li>
      <li>Purpose of Visit: Leisure, Holiday</li>
      <li>Requested Number of Entries: Multiple</li>
      <li>
        In Case of Transit: Do you have an entry permit? No. (You are obtaining a Travel Visa, not a
        Transit Visa, so answer no)
      </li>
      <li>Budget Available For Your Stay: $2,195</li>
      <li>Accommodations in Tanzania: Durban Hotel, Dar Es Salaam</li>
    </ul>
    <h4>Complete Visa Instructions</h4>
    {mailingCountry === 'United States' ? (
      <ul>
        <li>
          <a
            href="http://ec2-34-229-214-103.compute-1.amazonaws.com/wp-content/uploads/usa_visa_form.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Application (download)
          </a>
        </li>
        <li>
          <a
            href="https://www.givevolunteers.org/wp-content/uploads/Tanzania-Visa-Instructions-for-US-Citizens.docx"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instructions (download)
          </a>
        </li>
      </ul>
    ) : (
      ''
    )}

    {mailingCountry === 'United Kingdom' ? (
      <Fragment>
        <ul>
          <li>
            <a
              href="http://go.givevolunteers.org/ukcitizens-tanzaniavisa"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Instructions
            </a>
          </li>
        </ul>
        <p>**Wait until 60 days prior to apply!</p>
      </Fragment>
    ) : (
      ''
    )}

    {mailingCountry === 'Australia' ? (
      <ul>
        <li>
          {' '}
          <a
            href="http://go.givevolunteers.org/l/99972/2017-08-21/3qv2md/99972/53703/AUS_Citizens___Tanzania_Visa_Instructions.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Instructions
          </a>
        </li>
      </ul>
    ) : (
      ''
    )}

    {mailingCountry !== 'United States' &&
    mailingCountry !== 'United Kingdom' &&
    mailingCountry !== 'Australia' ? (
      <p>
        Visa requirements vary depending on your host country and citizenship. If a visa is
        required, apply for a Tourist Visa (or the equivalent). Contact the embassy nearest you for
        questions regarding your visa. Visit{' '}
        <a href="https://www.visahq.com/" target="_blank" rel="noopener noreferrer">
          VisaHQ.com
        </a>{' '}
        to see if you are required to obtain a travel visa based on your citizenship. Note: Visa HQ
        charges a fee. You do not have to order your visa through Visa HQ. You can apply for your
        visa directly from the embassy.{' '}
      </p>
    ) : (
      ''
    )}
  </div>
);

VisaChecklistModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  mailingCountry: PropTypes.string.isRequired,
};

export default VisaChecklistModal;
